<template>
  <section :class="`${this.isShowingMenu?'opened':''} myclass`">
      <div v-show="!Number.isNaN(courseId)" class="teacher-myclass-navbar" id="course_navbar" :style="navbarStyle">
        <div class="teacher-myclass-navbar-title teacher-myclass-green-font" style="margin: 3rem 2rem 1rem 2rem;">我的班級</div>
        <div class="teacher-myclass-navbar-title teacher-myclass-green-font" style="margin: 1rem 2rem 0.5rem 3rem;">{{courseInfo.name}}</div>
        <router-link :to="{name: 'ClassAnnouncement', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('announcement')}">班級通知</router-link>
        <router-link :to="{name: 'ClassInfo', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('info')}">{{isTeacher ? '班級設定' : '班級資料'}}</router-link>
        <router-link :to="{name: 'ClassWeeks', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('weeks')}">{{isTeacher ? '任務設置' : '班級任務'}}</router-link>
        <router-link v-if="isTeacher" :to="{name: 'ClassReport', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('report')}">任務數據</router-link>
        <router-link v-if="isTeacher" :to="{name: 'ClassGradebook', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('gradebook')}">學生進度</router-link>
        <router-link v-if="isTeacher" :to="{name: 'ClassMember', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('member')}">學生名單</router-link>
        <router-link v-if="isStudent" :to="{name: 'ClassProgress', query: {course: courseId}}" class="teacher-myclass-navItem" :class="{ 'active' : isActive('progress')}">學習進度</router-link>
        <a class="teacher-myclass-navItem" href="javascript:void(0)" @click="trigger_lti">uReply</a>
        <ltiBtn ref="ltiBtn" :courseId="courseId"></ltiBtn>
      </div>
      <div v-show="!Number.isNaN(courseId)" id="menu_button" @click="trigger_menu">
        <eva-icon fill="#397f1f" name="menu-outline" style="margin-right:0.2rem;"></eva-icon>
      </div>
    <div class="nav_background" @click="hide_menu" :style="navBackgroundStyle">
    </div>
    <div class="teacher-myclass-view" id="course_main_view" :style="{width: viewWidth}">
      <router-view style="height: calc( 100% - 6rem ); margin: 3rem auto; position: relative; padding: 0 15px;"/>
    </div>
  </section>
</template>
<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine"; // Import the theme engine

  @include md-register-theme("default", (
    primary: #ffffff, // The primary color of your application));
  ));

  *{
    margin: 0;
  }
  .myclass{
    display:flex;
    position: relative;
  }
  .teacher-myclass-view{
    flex: 1;
  }
  .teacher-myclass-light-green-font{
    color: #99CB32;
  }
  .teacher-myclass-green-font{
    color: #387f1f;
  }
  .teacher-myclass-navbar{
    flex: 0 0 18rem;
    display: flex;
    flex-direction: column;
  }
  .teacher-myclass-navbar-title{
    font-size: 1.5rem;
    font-weight: 600;
    color: #397f1f;
  }
  .active{
    background-color: #397f1f !important;
  }
  .teacher-myclass-navItem{
    margin: 1rem;
    font-size: 1.2rem;
    background-color: #99cc33;
    display: flex;
    width: 12rem;
    justify-content: center;
    align-self: center;
    padding: 1rem;
    border-radius: 1rem;
  }
   #menu_button {
    display: none;
  }
  @media screen and (max-width: 790px) {
    #menu_button {
      display: block;
      z-index: 10;
      position: absolute;
      top: 0;
      left: 0;
    }
    #course_navbar{
      right: 100%;
      transition: right 2s;
      position: absolute;
      background: white;
      overflow-y: scroll;
    }
    .opened #course_navbar{
      right: unset;
      z-index: 100;
    }
    .nav_background{
      width: 100vw;
      position: absolute;
      display: none;
    }
    .opened .nav_background{
      background: #000A;
      z-index: 99;
      display: block;
    }
  }
</style>

<script>
import $ from 'jquery'
import ltiBtn from '@/components/Weeks/LTI_btn'
import { EvaIcon } from 'vue-eva-icons'
export default {
  components: {
    ltiBtn,
    [EvaIcon.name]: EvaIcon
  },
  data () {
    return {
      courseInfo: {},
      viewWidth: '0px',
      isShowingMenu: false,
      navBackgroundStyle: '',
      navbarStyle: ''
    }
  },
  computed: {
    isTeacher: function () {
      return this.role === 'teacher'
    },
    isStudent: function () {
      return this.role === 'student'
    },
    courseId: function () {
      return parseInt(this.$route.query.course)
    },
    role: function () {
      return this.$parent.role
    },
    userId: function () {
      return this.$parent.id
    }
  },
  methods: {
    isActive: function (value) {
      return this.$route.path.indexOf(value) > -1
    },
    getCurrentCourseInfo: async function () {
      if (this.courseId) {
        try {
          await this.$store.dispatch('request', {
            route: `courses/${this.courseId}`
          }).then(res => {
            console.log(res)
            this.courseInfo = res
          })
        } catch (err) {
          console.log(err)
          alert('更新失敗')
        }
      }
    },
    trigger_lti: function () {
      this.$refs.ltiBtn.$refs.button.click()
    },
    show_menu: function (e) {
      this.isShowingMenu = true
    },
    hide_menu: function (e) {
      this.isShowingMenu = false
    },
    trigger_menu: function (e) {
      if (this.isShowingMenu) {
        this.hide_menu()
      } else {
        this.show_menu()
      }
      e.stopPropagation()
    }
  },
  watch: {
    courseId: function () {
      this.getCurrentCourseInfo()
    },
    isShowingMenu: function (isShow) {
      if (isShow) {
        $('html').css('overflow-y', 'hidden')
      } else {
        $('html').css('overflow-y', 'auto')
      }
    }
  },
  mounted () {
    this.getCurrentCourseInfo()
    this.$nextTick(function () {
      this.viewWidth = `calc( 90vw - ${$('#course_navbar').width() * 0.9}px )`
      this.navBackgroundStyle = `height: calc( 100vh + ${$('#footer').outerHeight()}px )`
      this.navbarStyle = `height: calc(100vh - ${$('#appHeader').outerHeight()}px )`
      $('#course_navbar>a').click(() => {
        console.log('a clicked')
        this.hide_menu()
      })
    })
  }
}
</script>
